<template>
  <a
    class="button button--blue facebookSignIn shortform-sign-up__button"
    @click="fbLoginClick"
  >
    <img
      class="button__img"
      src="@/assets.app/images/sign-up-facebook.svg"
      alt=""
    />
    <span class="button__text d-none d-md-inline">{{ title }} Facebook</span>
    <span class="button__text d-md-none">Facebook</span>
  </a>
</template>

<script setup lang="ts">
import { FacebookAuthView } from '@/models/auth/facebook'

const props = defineProps<{
  view: FacebookAuthView
  title: string
}>()

async function fbLoginClick(): Promise<void> {
  await props.view.start()
}
</script>
